import { api } from './index';

const BASE_PATH = '/api/internal/monthly_summaries';

export type CareerCount = {
  career: string;
  count: number;
  label: string;
};

export type MonthStats = {
  shiftsCount: number;
  patientsCount: number;
  newPatientsCount: number;
  completedShiftsCount: number;
  caregiversCount: number;
  newCaregiversCount: number;
  shiftsByCareer: CareerCount[];
};

export type NewPatient = {
  id: number;
  fullName: string;
  // The service start counts the patient as new; without one, the creation date.
  humanStartsOn: string | null;
  humanCreatedAt: string;
  groupNames: string[];
  serviceCategoryName: string | null;
  serviceSubcategoryName: string | null;
};

export type CareerOption = {
  career: string;
  label: string;
};

export type NewCaregiver = {
  id: number;
  fullName: string;
  humanCreatedAt: string;
  career: string;
  humanCareer: string;
  groupNames: string[];
};

export const monthlySummariesApi = {
  index(queryParams?: string): Promise<MonthStats> {
    return api({
      method: 'get',
      url: `${BASE_PATH}?${queryParams}`,
    }).then(response => response.data as MonthStats);
  },
  newPatients(queryParams?: string): Promise<NewPatient[]> {
    return api({
      method: 'get',
      url: `${BASE_PATH}/new_patients?${queryParams}`,
    }).then(response => response.data.patients);
  },
  newCaregivers(queryParams?: string): Promise<NewCaregiver[]> {
    return api({
      method: 'get',
      url: `${BASE_PATH}/new_caregivers?${queryParams}`,
    }).then(response => response.data.caregivers);
  },
  careers(queryParams?: string): Promise<CareerOption[]> {
    return api({
      method: 'get',
      url: `${BASE_PATH}/careers?${queryParams}`,
    }).then(response => response.data.careers);
  },
};
